import styled from 'styled-components';

const MultiTypeListItemStyle = styled.div`
	--mtliImageProportion: 62.25%;
	--mtliContentPaddingV: var(--sp4x);
	--mtliContentPaddingH: var(--sp4x);
	--mtliTitleMarginBottom: var(--sp4x);

	border-radius: var(--sp2x);
	overflow: hidden;
	height: 100%;

	.link-item {
		display: flex;
		flex-direction: column;
		height: 100%;

		.imageCont {
			--imagePaddingTop: var(--mtliImageProportion);

			img {
				transform: scale(1);
			}
		}

		.mtli-content-cont {
			flex: 1;
			padding: var(--mtliContentPaddingV) var(--mtliContentPaddingH);

			.mtli-title {
				margin-bottom: var(--mtliTitleMarginBottom);
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
			}

			.mtli-description {
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}
		}

		@media (hover: hover) {
			&:hover {
				.imageCont img {
					transform: scale(1.3);
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--mtliContentPaddingV: var(--sp3x);
		--mtliContentPaddingH: var(--sp3x);
		--mtliTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--mtliContentPaddingV: var(--sp3x);
		--mtliContentPaddingH: var(--sp3x);
		--mtliTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--mtliContentPaddingV: var(--sp3x);
		--mtliContentPaddingH: var(--sp3x);
		--mtliTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--mtliContentPaddingV: var(--sp3x);
		--mtliContentPaddingH: var(--sp3x);
		--mtliTitleMarginBottom: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--mtliContentPaddingV: var(--sp2x);
		--mtliContentPaddingH: var(--sp2x);
		--mtliTitleMarginBottom: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--mtliContentPaddingV: var(--sp2x);
		--mtliContentPaddingH: var(--sp2x);
		--mtliTitleMarginBottom: var(--sp2x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--mtliContentPaddingV: var(--sp2x);
		--mtliContentPaddingH: var(--sp2x);
		--mtliTitleMarginBottom: var(--sp2x);
	}
`;

export default MultiTypeListItemStyle;
